import { render, staticRenderFns } from "./InternosListado.vue?vue&type=template&id=1240ee7e&scoped=true"
import script from "./InternosListado.vue?vue&type=script&lang=js"
export * from "./InternosListado.vue?vue&type=script&lang=js"
import style0 from "./InternosListado.vue?vue&type=style&index=0&id=1240ee7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240ee7e",
  null
  
)

export default component.exports